
/* System defined core library */
import { Component, Input} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { Candidate } from '../../../../shared/models/scheduling/candidate.model';

/* User defined library/components */
import { BootstrapParams } from '../../../../../bootstrap-params';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';

@Component({
  selector: 'app-appointment-detail-confirmation',
  templateUrl: './appointment-detail-confirmation.component.html'
})

export class AppointmentDetailConfirmationComponent {

  public selectedTranslateLanguage: string = "";

  /* Service subscriptions */
  translateLanguage$: Subscription;
  candidate$: Subscription;

  /* Input-OutPut parameters decalartions */
  @Input() public feeText: string;
  @Input() public selectedAppointmentDetails: AppointmentDetail[] = [];
  @Input() public totalAmount: number = 0.00;
  @Input() public currencyCode: string;
  @Input() public discountAmount: number = 0.00;
  @Input() public balance: number = 0.00;

  public candidate: Candidate;
  public displayTaxDisclaimer: boolean;
  public taxAmt: number;

  /* Constructor declaration with required injected services */
  constructor(
    private translate: TranslateService,
    private selectedExamDetailService: SelectedExamDetailService,
    private bootstrapParams: BootstrapParams
  ) {
    this.candidate$ = this.selectedExamDetailService.candidate.subscribe(
      candidate => {
        this.candidate = candidate;
      }
    );

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );
  }

  ngOnInit() {
    if (this.bootstrapParams.displayTaxDisclaimer && (!this.selectedExamDetailService.isProctored && this.selectedAppointmentDetails[0].appointmentSlot.site.location.address.country === 'IND')) {
      this.displayTaxDisclaimer = true;
      this.taxAmt = 18;
    }
  }
}
